import React from 'react';
import { Card, CardContent, Theme, Typography } from '@mui/material';

import { colors, makeStyles } from '@material-ui/core';
import { WarningRounded as Warning } from '@material-ui/icons';

const useStyles = makeStyles((theme: Theme) => ({
  card: {
    marginTop: theme.spacing(1),
  },
  cardContent: {
    background: colors.red[600],
  },
  title: {
    display: 'flex',
    alignItems: 'center',
    color: '#fff',
  },
  icon: {
    marginRight: theme.spacing(2),
  },
  subtitle: {
    color: '#fff',
  },
}));

const ExpirationWarning: React.FC = () => {
  const classes = useStyles();

  return (
    <Card className={classes.card}>
      <CardContent className={classes.cardContent}>
        <Typography
          variant="h5"
          fontWeight="boler"
          component="div"
          align="center"
          className={classes.title}
        >
          <Warning className={classes.icon} fontSize="large" />
          Este prontuário não é atualizado há 2 meses!
        </Typography>

        <Typography className={classes.subtitle}>
          <br />
          Adicione uma Evolução ou, se for o caso, encerre o prontuário.
          <br />
          Se não houver nenhuma atualização ou o prontuário não for encerrado,
          seu acesso poderá ser bloqueado.
        </Typography>
      </CardContent>
    </Card>
  );
};

export default ExpirationWarning;
